'use client'

import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'
import { clickEvent } from '@marketplace-web/complaints/complaints-data'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { COMPLAINT_URL } from '../../constants/routes'

type Props = Partial<ConversationActionProps> & {
  transactionId?: number
  complaintId?: string | null
}

const ViewComplaint = ({
  transactionId,
  complaintId,
  primary,
  title,
  inverse,
  theme,
  size,
}: Props) => {
  const { track } = useTracking()

  const handleClick = () => {
    if (!complaintId) return

    navigateToPage(COMPLAINT_URL(complaintId))

    const targetDetails = {
      transaction_id: transactionId,
    }

    track(
      clickEvent({
        target: 'view_complaint',
      }),
    )

    track(
      clickEvent({
        target: 'view_issue_details',
        targetDetails: JSON.stringify(targetDetails),
      }),
    )
  }

  if (!transactionId || !complaintId) return null

  return (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleClick}
      testId="view-complaint-action-button"
    />
  )
}

export default ViewComplaint
